import {
    DENIED_PAYMENT_AUTHORIZATION_ERRORS,
    DeniedPaymentAuthorizationError,
} from 'dibs-error-tools/exports/ErrorMessages/constants';

export const DENIED_PAYMENT_ERRORS = Object.keys(
    DENIED_PAYMENT_AUTHORIZATION_ERRORS
) as DeniedPaymentAuthorizationError[];

export const getDeniedPaymentAuthorizationError = (
    errorMessage?: string
): DeniedPaymentAuthorizationError | undefined =>
    DENIED_PAYMENT_ERRORS.find(e => errorMessage?.includes(e));
